const COLUMNED_DROPDOWN_PLACEHOLDER = '---';

export { COLUMNED_DROPDOWN_PLACEHOLDER };
//# sourceMappingURL=constants.js.map
